import angular from "angular";
import resourceService from './resource.service';

let resourceModule = angular.module('resource.service', [])
.service('Resource', resourceService)

.name;

export default resourceModule;



// WEBPACK FOOTER //
// ./client/app/services/resourceService/resource.js